import React from "react";
import {UserService} from "../user/UserService";
import {getContainer} from "../ioc/IOCSetup";
import {AuthToken} from "../http/protocol";
import './styles/ProfilePageComponent.scss';
import {connect} from "react-redux";
import {Dispatch} from "redux";
import {logout} from "../user/UserActions";
import {t} from "../i18n";


interface OtherProps {
}

interface State {
    tokens:AuthToken[];
    currentTokenRef:number|null;
    isClickSeeAll?: boolean;
}

type Props = PropsFromDispatch & OtherProps;

export class TokenListComponent extends React.Component<Props, State> {
    userService:UserService;
    constructor(props:Props) {
        super(props);
        this.userService = getContainer().getUserService();
        this.state = {tokens:[], currentTokenRef:null, isClickSeeAll:false}
    }

    componentDidMount() {
        this.userService.getUserLoginTokens().then((tokens:AuthToken[]) => {
            let tokenRef = localStorage.getItem("tokenRefId");
            if(tokenRef != undefined && tokens.length > 0) {
                this.setState({currentTokenRef:Number(tokenRef), tokens:tokens})
            } else if(tokens.length > 0) {
                this.setState({tokens:tokens});
            }

        }).catch(e => console.log("failed to fetch tokens : ", e))
    }

    deleteToken = (id:number|undefined) => {
        if(id!=undefined) {
            this.userService.clearUserLoginToken(id).then((res) => {
                this.userService.getUserLoginTokens().then((tokens:AuthToken[]) => {
                    if(tokens.length >= 0) {
                        this.setState({tokens:tokens});
                    } else if (tokens.length === 0) {
                        this.setState({isClickSeeAll:false})
                    }

                }).catch(e => console.log("failed to fetch tokens : ", e))
            }).catch((e)=>{
                console.log("failed to delete token : ", e);
            })
        }

    }

    clearAllTokens() {
        this.userService.clearAllUserLoginTokens().then((res) => {
            this.userService.getUserLoginTokens().then((tokens:AuthToken[]) => {
                if(tokens.length >= 0) {
                    this.setState({tokens:tokens});
                } else if (tokens.length === 0) {
                    this.setState({isClickSeeAll:false})
                }
            }).catch(e => console.log("failed to fetch tokens : ", e))
        }).catch((e)=>{
            console.log("failed to delete token : ", e);
        })
    }

    renderList() {
        return(
            <div className={`device-table`}>
                <div className={`device-head`}>
                    <div className={`list-head`}>#</div>
                    <div className={`name-head`}>{t("profile.tokens.device-name")}</div>
                </div>

                {this.state.tokens.map((token)=>{
                    return(
                        <div key={token.id}>
                            <div className={`device-content big-screen`}>
                                <div className={`content-list`}>{token.id}</div>
                                <div className={`content-name`}>
                                    <div className={`name`}>{token.device} {token.id == this.state.currentTokenRef && `(${t("profile.tokens.current-device")})`}</div>
                                    <div className={`tButton`}><button onClick={()=>this.deleteToken(token.id)} className="btn btn-primary small">{t("profile.tokens.clear-token")}</button></div>
                                </div>
                            </div>
                            <div className={`device-content small-screen`}>
                                <div className={`comtent-wrapper`}>
                                    <div className={`content-list`}>{token.id}</div>
                                    <div className={`content-name`}>
                                        <div className={`name`}>{token.device} {token.id == this.state.currentTokenRef && `(${t("profile.tokens.current-device")})`}</div>
                                    </div>
                                </div>
                                <div className={`tButton`}><button onClick={()=>this.deleteToken(token.id)} className="btn btn-primary small">{t("profile.tokens.clear-token")}</button></div>
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }


    render() {
        const deviceTotal = this.state.tokens && this.state.tokens.length;
        return (
            <>
                <h4 className={`section`}><i className={`material-icons`}>devices</i>{t("profile.loggedinDevicesTitle")}&nbsp;
                    <span className={`total`}>{`[${deviceTotal}]`}</span>
                </h4>
                {this.state.tokens.length !== 0 && (
                    <div className={`detailWrapper loggedinDevices`}>
                        <div className={`item tokenList`}>
                            <div className={"itemWithTable"}>
                                <div className='row'>
                                    <div className='col-lg-12'>
                                        {this.renderList()}
                                    </div>
                                </div>
                                <div className='row delete-all'>
                                    <div className='col-lg-12 button-wrapper'>
                                        {this.state.tokens.length !== 1 && <button className="btn btn-primary small" onClick={() => this.clearAllTokens()}>{t("profile.tokens.clear-all-tokens")}</button>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </>
        )
    }
}


interface PropsFromDispatch {
    logout: typeof logout;
}

const mapStateToProps = () => {
    return {
    }
}

const mapDispatchToProps = (dispatch : Dispatch) => (
    {
        logout : () => dispatch(logout() as any),
    }
)

export default connect(mapStateToProps,mapDispatchToProps)(TokenListComponent);